import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, SearchX, Clock, Instagram } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function PainSection() {
  const {
    t
  } = useLanguage();
  const cards = [{
    icon: <SearchX className="w-8 h-8 text-red-400" data-id="element-264" />,
    quote: t('pain.quote1')
  }, {
    icon: <Clock className="w-8 h-8 text-orange-400" data-id="element-265" />,
    quote: t('pain.quote2')
  }, {
    icon: <Instagram className="w-8 h-8 text-pink-400" data-id="element-266" />,
    quote: t('pain.quote3')
  }];
  return <section className="py-24 bg-brand-bg relative" data-id="element-267">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-268">
        <div className="text-center mb-16" data-id="element-269">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center justify-center gap-2 bg-red-500/10 text-red-400 px-4 py-2 rounded-full text-sm font-semibold mb-6" data-id="element-270">
            <AlertCircle className="w-4 h-4" data-id="element-271" />
            <span data-id="element-272">{t('pain.badge')}</span>
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-4xl font-bold" data-id="element-273">
            {t('pain.title')}
          </motion.h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-274">
          {cards.map((card, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-brand-darker border border-white/5 p-8 rounded-2xl relative group hover:border-brand-purple/30 transition-colors" data-id="element-275">
              <div className="absolute -top-5 left-8 bg-brand-bg p-2 rounded-full border border-white/5 group-hover:border-brand-purple/30 transition-colors" data-id="element-276">
                {card.icon}
              </div>
              <p className="text-gray-300 italic text-lg leading-relaxed mt-4" data-id="element-277">
                "{card.quote}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}